
import { defineComponent } from "vue";

interface Data {
    agentMessage: string;
    showCursorBlinking: boolean;
}
export default defineComponent({
    name: "SurveyInactiveView",
    data(): Data {
        return {
            agentMessage: this.$t('survey.inactiveCampaignMessage'),
            showCursorBlinking: true,
        };
    },
    methods: {
        onAgentCursorMessageStreamingEnded() {
            this.showCursorBlinking = false;
        },
    },
});
